var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classifyList"},[_c('div',{staticClass:"classList"},_vm._l((_vm.toptype),function(item,index){return _c('div',{key:index,staticClass:"classItem",class:{
        checkSty: _vm.checkindex === item.menuId,
      },on:{"click":function($event){return _vm.toDetail(item)}}},[_c('div',[_c('span',[_vm._v(_vm._s(item.ancestors || item.menuName))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }